// extracted by mini-css-extract-plugin
module.exports = {"banner":"Heading_banner__1XAyj","headText":"Heading_headText__3Cjf2"};